// Campus photo for /colleges/old-dominion-university: CC0 1.0, by Packer1028, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ADragas_Hall_at_Old_Dominion_University.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/old-dominion-university/; credited under the photo.
const photo = {
    "slug": "old-dominion-university",
    "alt": "Dragas Hall at Old Dominion University, a brick and glass building with a curved glass entrance and steps, under a blue sky",
    "src": "/colleges/old-dominion-university/campus-1600.webp",
    "srcSmall": "/colleges/old-dominion-university/campus-800.webp",
    "srcMid": "/colleges/old-dominion-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/old-dominion-university/og.jpg",
    "title": "Dragas Hall at Old Dominion University",
    "author": "Packer1028",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ADragas_Hall_at_Old_Dominion_University.jpg",
    "read": "2026-10-01"
};

export default photo;
